import clsx from 'clsx';
import React from 'react';
import PropTypes from 'prop-types';
import { bsClass, getClassSet, prefix, splitBsProps } from './utils/bootstrapUtils';
import { jsx as _jsx } from "react/jsx-runtime";
class Table extends React.Component {
  render() {
    const {
      striped,
      bordered,
      condensed,
      hover,
      responsive,
      className,
      ...props
    } = this.props;
    const [bsProps, elementProps] = splitBsProps(props);
    const classes = {
      ...getClassSet(bsProps),
      [prefix(bsProps, 'striped')]: striped,
      [prefix(bsProps, 'bordered')]: bordered,
      [prefix(bsProps, 'condensed')]: condensed,
      [prefix(bsProps, 'hover')]: hover
    };
    const table = /*#__PURE__*/_jsx("table", {
      ...elementProps,
      className: clsx(className, classes)
    });
    if (responsive) {
      return /*#__PURE__*/_jsx("div", {
        className: prefix(bsProps, 'responsive'),
        children: table
      });
    }
    return table;
  }
}
Table.defaultProps = {
  bordered: false,
  condensed: false,
  hover: false,
  responsive: false,
  striped: false
};
export default bsClass('table', Table);